import React, { memo, useCallback, useEffect } from 'react';
import { Modal, notification } from 'antd';
import CommentsModalBody from '../CommentsModalBody/CommentsModalBody';
import { modalBodyStyle } from './constants';
import { useDispatch, useSelector } from 'react-redux';
import {
  resetCommentsData, setCommentsAction,
  setMaxPage, setPage
} from '../../../actions/commentsActions/commentsActions';

const { confirm } = Modal;

const CommentsModal = ({
  visible,
  onClose,
  title,
  footer,
  lightboxConfig,
  ...props
}) => {
  const currentComment = useSelector(
    (state) => state.commentsChatStore.currentComment
  );
  const error = useSelector((state) => state.commentsChatStore.error);

  const onModalCancel = useCallback(() => {
    if (
      currentComment.message ||
      currentComment.attachments.images.length ||
      currentComment.attachments.files.length
    ) {
      confirmLeaveMessages(onClose);
    } else {
      onClose();
    }
  }, [currentComment]);

  const openErrorNotification = (description) => {
    notification['error']({
      message: 'Ошибка',
      description,
    });
  };

  const confirmLeaveMessages = (onClose) => {
    confirm({
      title: 'Вы действительно хотите выйти?',
      onOk() {
        onClose();
      },
      onCancel() {},
    });
  };

  useEffect(() => {
    if (error.isError) {
      openErrorNotification(error.message);
    }
  }, [error]);

  return (
    <Modal
      width={590}
      visible={visible}
      centered={true}
      bodyStyle={modalBodyStyle}
      title={title}
      onCancel={onModalCancel}
      footer={footer}
      {...props}
    >
      <CommentsModalBody lightboxConfig={lightboxConfig}/>
    </Modal>
  );
};

export default memo(CommentsModal);
